import { UserBalanceReconciliation } from 'types';

import { createCrudApi } from './crud.api';

export const usersBalanceReconciliationApi =
  createCrudApi<UserBalanceReconciliation>('/users-balance-reconciliation');
